import {combineReducers} from "redux";
import {RootState} from "./RootState";
import {routerReducer} from "react-router-redux";
import userReducer from "../user/reducer";
import contactReducer from "../contact/reducer";
import siteReducer from "../site/reducer";
import leadReducer from "../lead/reducer";
import noteReducer from "../note/reducer";
import addressHistoryReducer from "../addressHistory/reducer";
import notificationReducer from "../notification/reducer";
import appointmentReducer from "../appointment/reducer";
import userLocationReducer from "../userLocation/reducer"
import settingsReducer from "../settings/reducer";
import quotesReducer from "../quote/reducer";
import organizationReducer from "../organization/reducer";
import assetsReducer from "../asset/reducer";
import taskReducer from "../task/reducer";
import brandsReducer from "../brand/reducer";
import acquisitionChannelsReducer from "../acquisitionChannel/reducer";
import smsReducer from "../sms/reducer";
import leadTypeReducer from "../leadType/reducer";
import jobReducer from "../job/reducer";
import jobTypeReducer from "../jobType/reducer";
import categoryReducer from "../category/reducer";
import jobStatusReducer from "../jobStatus/reducer";
import leadStatusReducer from "../leadStatus/reducer";
import assetCategoryReducer from "../assetCategory/reducer";
import surveyReducer from "../survey/reducer";
import partnerBrandsReducer from "../partnerBrand/reducer";
import merchantsReducer from "../merchant/reducer";
import invoicesReducer from "../invoice/reducer";
import customFieldsReducer from "../customField/reducer"
import billsReducer from "../bill/reducer";
import sidebarOrderReducer from "../sidebarOrder/reducer";
import billOfMaterialsReducer from "../billOfMaterials/reducer";
import financeProductsReducer from "../financeProduct/reducer";
import utilityReducer from "../utility/reducer";
import {Action} from "redux-actions";
import {USER_LOGOUT} from "../../action/user/actionType";

const rootReducer = combineReducers<RootState>(
	{
		router: routerReducer,
		user: userReducer,
		contact: contactReducer,
		site: siteReducer,
		lead: leadReducer,
		note: noteReducer,
		addressHistory: addressHistoryReducer,
		notification: notificationReducer,
		appointment: appointmentReducer,
		userLocation: userLocationReducer,
		settings: settingsReducer,
		quote: quotesReducer,
		organization: organizationReducer,
		asset: assetsReducer,
		task: taskReducer,
		brand: brandsReducer,
		acquisitionChannel: acquisitionChannelsReducer,
		sms: smsReducer,
		leadType: leadTypeReducer,
		job: jobReducer,
		jobType: jobTypeReducer,
		category: categoryReducer,
		jobStatus: jobStatusReducer,
		leadStatus: leadStatusReducer,
		assetCategory: assetCategoryReducer,
		survey: surveyReducer,
		partnerBrand: partnerBrandsReducer,
		merchant: merchantsReducer,
		invoice: invoicesReducer,
		customFields: customFieldsReducer,
		bill: billsReducer,
		sidebarOrder: sidebarOrderReducer,
		billOfMaterials: billOfMaterialsReducer,
		financeProduct: financeProductsReducer,
		utility: utilityReducer
	});

const appReducer = (state: RootState, action: Action<any>) => {
	if (action.type === USER_LOGOUT) {
		const reducer = rootReducer(undefined, action);
		reducer.settings = state.settings;
		return reducer;
	}
	else
		return rootReducer(state, action);
};


export default appReducer;
